import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { currentDateOfTheMonth } from "../../components/common-data/Converts";
import {
  fetchLateCheckinsReportData,
  fetchLateCheckinsStatsData,
} from "../../redux/reducers/apiSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import LateCheckinListings from "../../components/trainer-report/staff-attendance-report/late-checkins/LateCheckinListings";
import DetailModHeader from "../../components/common-components/DetailModHeader";
import LateCheckinCalenderLogs from "../../components/trainer-report/staff-attendance-report/late-checkins/LateCheckinCalenderLogs";
import LateCheckinStats from "../../components/trainer-report/staff-attendance-report/late-checkins/LateCheckinStats";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const LateCheckins = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { lateCheckinsReportDataLoading, lateCheckinsStatsDataLoading } =
    useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStaff: "",
    selectedStaffType: "",
    selectedShiftType: "",
    selectedShiftTime: "",
    selectedHalfDayCheckinStatus: "",
    selectedStartDate: currentDateOfTheMonth,
    selectedEndDate: currentDateOfTheMonth,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    user_id: allFilters.selectedStaff?.value || "",
    account_type: allFilters.selectedStaffType?.value || "",
    shift_type: allFilters.selectedShiftType?.value || "",
    slot_time: allFilters.selectedShiftTime?.value || "",
    half_day: allFilters.selectedHalfDayCheckinStatus?.value || "",
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getLateCheckinsStat(filters) {
    dispatch(
      fetchLateCheckinsStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getLateCheckinsReport(filters) {
    dispatch(
      fetchLateCheckinsReportData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCombineReload() {
    getLateCheckinsReport(filters);
    getLateCheckinsStat(filters);
  }

  useEffect(() => {
    getLateCheckinsStat(filters);
    getLateCheckinsReport(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      user_id: allFilters.selectedStaff?.value || "",
      account_type: allFilters.selectedStaffType?.value || "",
      shift_type: allFilters.selectedShiftType?.value || "",
      slot_time: allFilters.selectedShiftTime?.value || "",
      half_day: allFilters.selectedHalfDayCheckinStatus?.value || "",
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedStaff,
    allFilters.selectedStaffType,
    allFilters.selectedShiftType,
    allFilters.selectedShiftTime,
    allFilters.selectedHalfDayCheckinStatus,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  return (
    <HelmetWrapper title="WTF: Late Checkins">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "view_details" ? "" : "mod-width-50p"
            }`}>
            <DetailModHeader
              info={modValues.rowData}
              onClose={() => {
                onCloseModal();
                getCombineReload();
              }}
            />

            {modValues.modName === "view_details" ? (
              <LateCheckinCalenderLogs
                userInfoData={userInfoData}
                rowData={modValues.rowData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Late Checkins"}
              isReload={getCombineReload}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"staff-attendance-report"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              isLoading={
                lateCheckinsReportDataLoading || lateCheckinsStatsDataLoading
              }
              clickedCard={"late-checkins"}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <LateCheckinStats />
          </Col>
        </Row>

        <Row>
          <Col>
            <LateCheckinListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              isDateFilterApplied={filters.date_from && filters.date_to}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default LateCheckins;
